import React from 'react';

import {get, includes} from 'lodash-es';
import PropTypes from 'prop-types';

import {onSuggestionKeyDown} from 'static/three-oh/src/components/GlobalLayout/GlobalNav/GlobalNavSearch/helpers';
import {
  GlobalNavSearchSuggestion,
} from 'static/three-oh/src/components/GlobalLayout/GlobalNav/GlobalNavSearch/SearchSuggestions/SuggestionParts/SuggestionParts';

import styles from './styles.scss';

export default class Suggestion extends React.Component {
  static propTypes = {
    focusNext: PropTypes.func.isRequired,
    focusPrevious: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    searchId: PropTypes.string,
    suggestion: PropTypes.object.isRequired,
    tabIndex: PropTypes.number.isRequired,
    isGlobalNavSearch: PropTypes.bool.isRequired,
    onSuggestionDismiss: PropTypes.func,
  }

  static defaultProps = {
    isGlobalNavSearch: false,
  }

  state = {
    isSelected: false,
  };

  /**
   * Handle events where the suggestion loses focus.
   * @param {Event} event - the event.
   */
  onBlur = () => {
    this.setState({isSelected: false});
  }

  /**
   * Handle suggestion clicks by triggering a callback function.
   */
  onClick = (click = true) => {
    const suggestionText = get(this.props.suggestion, 'text', '');
    const eventProperties = {
      search_id: this.props.searchId,
      text: suggestionText
    };

    this.props.onClick(suggestionText, eventProperties, click);
  }

  /**
   * Handle events where the suggestion gains focus.
   * @param {Event} event - the event.
   */
  onFocus = () => {
    this.setState({isSelected: true});
    const suggestionText = get(this.props.suggestion, 'text', '');
    this.props.onFocus(suggestionText);
  }

  /**
   * Handle keydown events.
   * @param {Event} event - the keyboard event.
   */
  onKeyDown = (event) => {
    if (includes(['Enter', ' '], event.key)) {
      this.onClick(false);
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      this.props.focusNext(this.props.tabIndex);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      this.props.focusPrevious(this.props.tabIndex);
    }
  };

  onKeyDownForGlobalNavSearchSuggestion = (event) => {
    const params = {
      event: event,
      onSuggestionSubmit: () => this.onClick(false),
      onSuggestionDismiss: this.props.onSuggestionDismiss,
      onSuggestionTab: this.props.onSuggestionDismiss,
    };
    onSuggestionKeyDown(params);
  };

  render() {
    const {isGlobalNavSearch, suggestion} = this.props;
    const suggestionText = get(suggestion, 'text', '');

    return (
      isGlobalNavSearch ?
          (
            <GlobalNavSearchSuggestion
              isSelected={this.state.isSelected}
              onClick={this.onClick}
              onKeyDown={this.onKeyDownForGlobalNavSearchSuggestion}
              suggestionText={suggestionText}
              isStandard={false}
            />
          ) :
          (
            <li
              aria-selected={this.state.isSelected}
              className={`search-suggestion ${styles.suggestion}`}
              data-qa-selector="search_suggestion"
              onBlur={this.onBlur}
              onClick={this.onClick}
              onFocus={this.onFocus}
              onKeyDown={this.onKeyDown}
              role="option"
              tabIndex={this.props.tabIndex}
            >
              <p className={styles.textInOverlay}>{suggestionText}</p>
            </li>
          )
    );
  }
}
